import { render, staticRenderFns } from "./ListNew.vue?vue&type=template&id=6b9423a2"
import script from "./ListNew.vue?vue&type=script&lang=js"
export * from "./ListNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports